// src/pages/SignInPage.js
import React from 'react';
import SignInForm from '../components/SignInForm';
import '../App.css';
import Header from '../components/Header';


const SignInPage = () => (
    <>
    <Header />
    <div className="app-container">
      <div className="left-image">
        <img src="/image.png" alt="Invoices Illustration" />
      </div>
    <SignInForm />
  </div>
  </>
);

export default SignInPage;
